export default __webpack_public_path__ + "static/media/working.8f3bd414.png";